import React from "react"
import { graphql } from "gatsby"
// import Img from "gatsby-image/withIEPolyfill"
import idx from "idx"

import { Header, HeroGrid, TechSpecsList, Banner, Footer } from "@components/sections"

import { ActionLink, Meta, PageCircles } from "@shared"

import { CONSTANTS } from "@data"
import { logTool, getFileLink } from "@jsUtils"

import Styles from "./tech-specs.module.scss"

const { PAGE_NAMES, THEMES, COLORS } = CONSTANTS

const log = logTool()

/**
 * Safely get the product title, product link, and page title
 * @param {object} productObj - contentful page/product object
 * @param {string} title - page title
 * @returns {object}
 */
const getTitle = (productObj, title) => {
  const product = idx(productObj, _ => _.title)
  const prodSlug = idx(productObj, _ => _.slug)
  return {
    product,
    prodSlug,
    page: title
  }
}

/**
 * Page Template
 * Render a Tech Specs page with this template
 * @param {object} props - react props
 */
const ProductTechSpec = props => {
  const { data } = props
  const { contentfulProductSpecs, contentfulPageMeta } = data

  const { product, title, specs, download, bottomBanner } = contentfulProductSpecs

  const specsDetail = getTitle(product, title)
  const downloadLink = getFileLink(download)

  log("Render Tech-Specs... ", contentfulProductSpecs, data)

  return (
    <>
      <Meta base={contentfulPageMeta} page={contentfulProductSpecs} />
      <Header theme={THEMES.LIGHT} pageColor={COLORS.LIGHT} />
      <HeroGrid
        theme={THEMES.LIGHT}
        color={COLORS.FLURO}
        page={PAGE_NAMES.TECH_SPECS}
        content={{
          headline: specsDetail.page,
          inline: specsDetail.product
        }}
        classes={{
          extraHeroSection: Styles.specsWrapper,
          extraHeroWrapperRow: Styles.headerWrapper,
          extraPageHeadingContent: Styles.pageHeadingContent,
          inlineHeader: Styles.tag
        }}
      />
      <PageCircles
        settings={{
          items: [
            {
              align: "right",
              color: COLORS.WORKS,
              fromTop: "12vh",
              orbit: true,
              size: "medium"
            },
            {
              align: "right",
              color: COLORS.WORKS,
              fromTop: "2400px",
              size: "small"
            },
            {
              align: "left",
              color: COLORS.WORKS,
              fromTop: "3400px",
              orbit: true,
              size: "large"
            }
          ]
        }}
      />
      {/* {downloadLink && (
        <div className={Styles.download}>
          <ActionLink
            download
            linkTarget={downloadLink}
            text="Download PDF"
            extraClass={Styles.actionLink}
          />
        </div> */}
      {/* )} */}
      <TechSpecsList hasGrid data={specs} />
      <Banner data={bottomBanner} />
      <Footer />
    </>
  )
}

export default ProductTechSpec

export const pageQuery = graphql`
  query($slug: String!) {
    contentfulPageMeta(id: { eq: "423babd8-0278-5b2e-85f6-77fb7ee55bee" }) {
      ...GlobalMetaData
    }
    contentfulProductSpecs(slug: { eq: $slug }) {
      pageMeta {
        ...PageMetaData
      }
      product {
        title
        slug
      }
      slug
      title
      download {
        file {
          url
        }
      }
      specs {
        title
        id
        description {
          childMarkdownRemark {
            html
          }
        }
      }
      bottomBanner {
        ...BannerSection
      }
    }
  }
`
